<template>
  <div class="base-select">
    <el-select
      v-model="selectValue"
      :multiple="multiple"
      v-bind="$attrs"
      @change="handleSelectChange"
      v-on="$listeners"
    >
      <el-option
        v-for="option in optionsList"
        :key="option[optionsProp.value]"
        :label="option[optionsProp.label]"
        :value="option[optionsProp.value]"
      />
    </el-select>
  </div>
</template>

<script>
import * as api from '@/api/common'
import { isFunction } from 'lodash'
export default {
  name: 'BaseSelect',
  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    optionsProp: {
      type: Object,
      default: () => ({
        value: 'value',
        label: 'label'
      })
    },
    dataFromOut: {
      type: Boolean,
      default: false
    },
    api: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: () => ({})
    },
    resultTransformFn: {
      type: Function,
      default: (result) => result
    }
  },
  data() {
    return {
      apiOptionsList: []
    }
  },
  computed: {
    selectValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    optionsList: {
      get() {
        if (this.dataFromOut) {
          return this.options
        }
        return this.apiOptionsList
      },
      set(val) {
        this.apiOptionsList = val
      }
    }
  },
  watch: {
    params: {
      handler() {
        this.getOptionsList()
      },
      deep: true
    }
  },
  created() {
    if (!this.dataFromOut) {
      this.getOptionsList()
    }
  },
  methods: {
    async getOptionsList() {
      if (!this.api) {
        return
      }
      const { isSuccess, data } = await api.getAction({
        url: this.api,
        params: this.params
      })
      if (isSuccess && data.list.length > 0) {
        if (isFunction(this.resultTransformFn)) {
          this.optionsList = this.resultTransformFn(data.list)
        } else {
          this.optionsList = data.list
        }
        this.$emit('finish', this.optionsList)
      } else {
        this.optionsList = []
      }
    },
    handleSelectChange(value) {
      if (this.multiple) {
        const options = []
        this.optionsList.forEach(item => {
          if (value.includes(item[this.optionsProp.value])) {
            options.push(item)
          }
        })
        this.$emit('select', options)
      } else {
        this.optionsList.forEach(item => {
          if (item[this.optionsProp.value] === value) {
            this.$emit('select', item)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
